module.exports = __webpack_public_path__ + "static/media/guy.70721e76.svg";